import { render, staticRenderFns } from "./DsioSort.vue?vue&type=template&id=3f21d274&"
import script from "./DsioSort.vue?vue&type=script&lang=js&"
export * from "./DsioSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/su_laetis/workspaces/structure-wordpress-php8/httpsdocs/plugins/lae-elementor-diffusio/libs/diffusio/ressources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f21d274')) {
      api.createRecord('3f21d274', component.options)
    } else {
      api.reload('3f21d274', component.options)
    }
    module.hot.accept("./DsioSort.vue?vue&type=template&id=3f21d274&", function () {
      api.rerender('3f21d274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/DsioSort.vue"
export default component.exports